import axios from "axios";
import { useEffect, useState } from "react";
import Genres from "../../components/Genres";
import SingleContent from "../../components/SingleContent/SingleContent";
import useGenre from "../../hooks/useGenre";
import CustomPagination from "../../components/Pagination/CustomPagination";

const Movies = () => {
  const [genres, setGenres] = useState([]);
  const [selectedGenres, setSelectedGenres] = useState([]);
  const [page, setPage] = useState(1);
  const [content, setContent] = useState([]);
  const [numOfPages, setNumOfPages] = useState();
  const genreforURL = useGenre(selectedGenres);
  // console.log(selectedGenres);

  const fetchMovies = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/discover/movie?api_key=005f6669d892bb00a78077c968aabd11&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=${page}&with_genres=${genreforURL}`
      );
    setContent(data.results);
    setNumOfPages(data.total_pages);
  };

  useEffect(() => {
    window.scroll(0, 0);
    fetchMovies();
    // eslint-disable-next-line
  }, [page, genreforURL]);

  return (
    <div>
      <span className="pageTitle">Movies</span>
      <Genres
        type="movie"
        selectedGenres={selectedGenres}
        setSelectedGenres={setSelectedGenres}
        genres={genres}
        setGenres={setGenres}
        setPage={setPage}
      />
      <div className="trending">
        {content &&
          content.map((c) => (
            <SingleContent
              key={c.id}
              id={c.id}
              poster={c.poster_path}
              title={c.title || c.name}
              date={c.first_air_date || c.release_date}
              media_type="movie"
              vote_average={c.vote_average}
            />
          ))}
      </div>
      {numOfPages > 1 && (
        <CustomPagination setPage={setPage} numOfPages={numOfPages} />
      )}
    </div>
  );
};

export default Movies;





/*import axios from "axios";
import { useEffect, useState } from "react";
import CustomPagination from "../../components/Pagination/CustomPagination";
import SingleContent from "../../components/SingleContent/SingleContent";
import useGenre from "../../hooks/useGenre";
import Genres from "../../components/Genres/Genres";

const Movies = () => {
  const [genres, setGenres] = useState([]);
  const [selectedGenres, setSelectedGenres] = useState([]);
  const [page, setPage] = useState(1);
  const [content, setContent] = useState([]);
  const [numOfPages, setNumOfPages] = useState();

  const fetchMovies = async () => {
    const { data }= await axios.get(
      `https://api.themoviedb.org/3/discover/movie?api_key=005f6669d892bb00a78077c968aabd11&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=${page}1&with_watch_monetization_types=flatrate`
      );

      setContent(data.results);
      setNumOfPages(data.total_pages);
  };

  useEffect(() => {
    window.scroll(0, 0);
    fetchMovies();
    // eslint-disable-next-line
  }, [genreforURL, page]);

  return (
      <div>
          <span className='pageTitle'>Movies</span>
          <div className='trending'>
                {content && content.map((c) => ( 
                <SingleContent 
                  key={c.id} 
                  id={c.id} 
                  poster={c.poster_path} 
                  title={c.title || c.name} 
                  date={c.first_air_date || c.release_date} 
                  media_type="movie"
                  vote_average={c.vote_average}
                />
                ))}
            </div>
            {numOfPages > 1 && (
              <CustomPagination  setPage={setPage} numOfPages={numOfPages} />
            )}
      </div>
    );
  };
  
  export default Movies;
//
      `https://api.themoviedb.org/3/discover/movie?api_key=005f6669d892bb00a78077c968aabd11&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=${page}1&with_watch_monetization_types=flatrate`
    




//https://api.themoviedb.org/3/discover/movie?api_key=005f6669d892bb00a78077c968aabd11&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page=${page}&with_genres=${genreforURL}

  */